<template>
  <div class="check-item">
    <div class="row">
      <div class="col-sm-7">{{ i18n.apiAccess }}</div>
      <div class="col-sm-3"></div>
      <div class="col-sm-2">
        <checker-status :result="result.value"></checker-status>
      </div>
    </div>
    <div class="row" v-for="text in result.text" :key="text">
      <div class="col-sm-12">
        <div class="alert alert-danger" v-show="result.value === 'failed'">
          <span>
            {{ text }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckerStatus from './CheckerStatus'
import { fetchDataWithTimeout } from '../utils'

const checkerName = 'api-connection-checker'

export default {
  name: checkerName,
  data() {
    return {
      status: 'in-progress',
      result: {
        value: '',
        text: []
      },
      i18n: window.SYSTEM_CHECK.i18n
    }
  },
  computed: {
    cdnCheckUrl() {
      return window.SYSTEM_CHECK.cdnCheckUrl
    },
    region() {
      if (window.location.hostname.includes('.com')) {
        return 'us-west-1'
      } else if (window.location.hostname.includes('.us')) {
        return 'us-east-1'
      }
      return 'eu-central-1'
    },
    domain() {
      if (window.location.hostname.includes('.com')) {
        return '6connex.com'
      } else if (window.location.hostname.includes('.us')) {
        return '6connex.us'
      }
      return '6connex.eu'
    }
  },
  components: {
    CheckerStatus
  },
  created() {
    this.$emit('initialized', { name: checkerName })
  },
  async mounted() {
    const pamsApiUrl = `https://api-${this.region}.${this.domain}`
    const apiGatewayApiUrl = `https://apigateway.${this.domain}`

    const urls = [pamsApiUrl, apiGatewayApiUrl]

    this.checkApisConnection(urls)
  },
  methods: {
    async checkApisConnection(apiUrls) {
      try {
        const responses = await fetchDataWithTimeout(apiUrls)
        responses.forEach(response => {
          const { status, url } = response

          if (status === 'fulfilled') {
            this.result.value = 'passed'
          } else {
            this.result.value = 'failed'
            this.result.text.push(`Can't access ${url}`)
          }
        })
      } catch (error) {
        console.error('Fetch error:', error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ApiConnectionChecker.vue?eb19c428